<template>
  <div class="cabinet-page" :class="{ 'is-loading': loading }">
    <app-cells><h1 class="title">{{ $t('nav.heslb') }}</h1></app-cells>
    <app-page-loader v-if="loading" />
    <cabinet-state
      v-else-if="loadError"
      type="error"
      :title="$t('heslb.unavailable')"
      :message="$t('common.pleaseRetry')"
      @retry="loadLoans"
    />
    <cabinet-state
      v-else-if="!loans.length"
      type="empty"
      :title="$t('heslb.empty')"
      :message="$t('heslb.emptyHelp')"
    />
    <template v-else>
      <section v-if="currentLoans.length" class="cabinet-group">
        <h2 class="cabinet-group__title cabinet-group__title--current">{{ $t('common.current') }}</h2>
        <heslb-card v-for="loan in currentLoans" :key="loan.id" :loan="loan" />
      </section>
      <section v-if="historyLoans.length" class="cabinet-group">
        <h2 class="cabinet-group__title cabinet-group__title--history">{{ $t('common.history') }}</h2>
        <heslb-card v-for="loan in historyLoans" :key="loan.id" :loan="loan" />
      </section>
    </template>
  </div>
</template>

<script>
import { getPersonalCabinetHeslbLoans } from '@/http'
import CabinetState from './CabinetState'
import HeslbCard from './HeslbCard'

export default {
  name: 'PersonalCabinetHeslb',
  components: { CabinetState, HeslbCard },
  data() {
    return {
      loading: true,
      loadError: false,
      loans: [],
    }
  },
  computed: {
    currentLoans() {
      return this.loans.filter(loan => loan.status.code === 'active')
    },
    historyLoans() {
      return this.loans.filter(loan => loan.status.code !== 'active')
    },
  },
  created() { this.loadLoans() },
  methods: {
    loadLoans() {
      this.loading = true
      this.loadError = false
      return getPersonalCabinetHeslbLoans()
        .then(response => { this.loans = response.data })
        .catch(() => { this.loadError = true })
        .finally(() => { this.loading = false })
    },
  },
}
</script>

<style lang="sass" scoped>
.cabinet-group + .cabinet-group
  margin-top: 24px

.cabinet-group__title
  margin-bottom: 12px
  padding: 9px 12px
  border-left: 4px solid
  border-radius: 0 8px 8px 0
  font-size: 14px
  font-weight: 600
  letter-spacing: 1px
  text-transform: uppercase

.cabinet-group__title--current
  border-color: $color-theme
  background-color: #f1f7e9
  color: #4f8d12

.cabinet-group__title--history
  border-color: #8a8a8a
  background-color: #f3f3f3
  color: #5f5f5f
</style>
